import * as React from "react"
import styles from "./NotAuthorized.module.scss"

import { AppRoutes } from "@constants/AppRoutes.ts"
import { useNavigate } from "react-router-dom"
import { useLoggedUserData } from "@hooks/useLoggedUserData.ts"
import { AppAuthorizedProfiles } from "@constants/AppAuthorizedProfiles.ts"

import AppText from "@components/general/AppText/AppText.tsx"
import DsButton from "@components/general/DsButton/DsButton.tsx"
import DvBackground from "@components/layout/DvBackground/DvBackground.tsx"

interface INotFoundProps {
	className?: string
}

const NotAuthorized: React.FC<INotFoundProps> = (props) => {
	const navigate = useNavigate()
	const { loggedUser } = useLoggedUserData()

	const goToHome = () => {
		switch (loggedUser?.profileType) {
			case AppAuthorizedProfiles.BACKOFFICE:
				navigate(AppRoutes.backofficeHome)
				break
			default:
				navigate(AppRoutes.home)
				break
		}
	}

	return (
		<div className={`${styles.not_found} ${props.className || ""}`}>
			<DvBackground />

			<div className={styles.dv_error_message_container}>
				<div className={styles.body}>
					<AppText className={styles.error_code}>403</AppText>

					<div className={styles.content}>
						<div className={styles.message}>
							<AppText
								className={styles.title}
								textKey="access_denied"
								tag="h1"
							/>
							<main className={styles.error_body}>
								<AppText
									className={styles.error_details}
									textKey="message_page_allowed"
									tag="p"
								/>
							</main>
						</div>

						<div className={styles.footer}>
							{loggedUser?.profileType && (
								<DsButton
									type="primary"
									textKey="go_to_home"
									onClick={goToHome}
								/>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default React.memo(NotAuthorized)
